module.exports = __webpack_public_path__ + "icon-assessoria.png?4411118fa17dbf6a125bec8deea31d68";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-assessoria.png
// module id = 229
// module chunks = 0